import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './css/Navbar.css';

const SuperAdminMenu = [
  { text: 'Dashboard', icon: 'fa-tachometer-alt', path: '/super-admin/dashboard' },
  { text: 'Websites', icon: 'fa-globe', path: '/super-admin/websites' },
  { text: 'Admins', icon: 'fa-users-cog', path: '/super-admin/admins' },
  { text: 'Analytics', icon: 'fa-chart-line', path: '/super-admin/analytics' },
];

const SiteAdminMenu = [
  { text: 'Dashboard', icon: 'fa-tachometer-alt', path: '/site-admin/dashboard' },
  { text: 'Posts', icon: 'fa-newspaper', path: '/site-admin/posts' },
  { text: 'Events', icon: 'fa-calendar-alt', path: '/site-admin/events' },
  { text: 'Media', icon: 'fa-photo-video', path: '/site-admin/media' },
  { text: 'Settings', icon: 'fa-cogs', path: '/site-admin/settings' },
];

const Navbar = ({ onMobileMenuToggle }) => {
  const location = useLocation();
  const { user } = useAuth();
  const currentPath = location.pathname;

  const getPageTitle = () => {
    const menu = currentPath.startsWith('/super-admin') ? SuperAdminMenu : SiteAdminMenu;
    const menuItem = menu.find(item => item.path === currentPath);
    return menuItem ? menuItem.text : 'Dashboard';
  };

  const pageTitle = getPageTitle();

  const getUserInitials = () => {
    if (!user || !user.name) return 'U';
    return user.name.split(' ').map(n => n[0]).join('').toUpperCase();
  };

  return (
    <div className="header">
      <div className="header-left">
        <button className="mobile-menu-btn" onClick={onMobileMenuToggle}>
          <i className="fas fa-bars"></i>
        </button>
        <h2>{pageTitle}</h2>
        
        {/* Breadcrumb Navigation */}
        <nav className="breadcrumb">
          <div className="breadcrumb-item">
            <i className="fas fa-home"></i>
            <span>Home</span>
          </div>
          <div className="breadcrumb-item active">
            <span>{pageTitle}</span>
          </div>
        </nav>
      </div>

      <div className="nav-actions">
        <button className="nav-action-btn" title="Notifications">
          <i className="fas fa-bell"></i>
          <span className="notification-badge"></span>
        </button>
        
        <button className="nav-action-btn" title="Messages">
          <i className="fas fa-envelope"></i>
        </button>
        
        <button className="nav-action-btn" title="Settings">
          <i className="fas fa-cog"></i>
        </button>
      </div>

      <div className="user-info">
        <div className="user-details">
          <span className="user-name">{user?.name || 'Joshy '}</span>
          <span className="user-role">
            {user?.role === 'super_admin' ? 'Super Administrator' :
             user?.role === 'site_admin' ? 'Site Administrator' : 'Administrator'}
          </span>
        </div>
        <div className="user-avatar-nav">
          {getUserInitials()}
        </div>
      </div>
    </div>
  );
};

export default Navbar;